// import i18n from "../i18n";
import UkFlag from "@/assets/images/flags/flag-uk.svg";
import DeFlag from "@/assets/images/flags/flag-de.svg";
import { UserLanguage } from "@/enum/user.enum";

export const languages = [
	{
		name: "English",
		shortName: "En",
		code: UserLanguage.EN,
		image: UkFlag,
	},
	{
		name: "Deutsch",
		shortName: "De",
		code: UserLanguage.DE,
		image: DeFlag,
	},
];
